module.exports = __webpack_public_path__ + "static/media/logo-analytics.27dd0191.svg";